import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import {
    getTransmissions,
    getTransmission,
    createTransmission,
    editTransmission,
    deleteTransmission,
} from "api/transmissionApi"

export const TRANSMISSION_QUERY_KEY = "transmissions"

// Fetch list of transmissions
export const useTransmissions = (params = {}, enabled = true) => {
  return useQuery({
    queryKey: [TRANSMISSION_QUERY_KEY, params],
    queryFn: () => getTransmissions(params),
    keepPreviousData: true,
    enabled
  })
}

// Fetch single transmission by ID
export const useTransmission = id => {
  return useQuery({
    queryKey: [TRANSMISSION_QUERY_KEY, id],
    queryFn: () => getTransmission(id),
    enabled: !!id,
  })
}

// Create a new transmission
export const useCreateTransmission = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: createTransmission,
    onSuccess: data => {
      if (data?.success) {
        queryClient.invalidateQueries([TRANSMISSION_QUERY_KEY])
      }
    },
  })
}

// Edit an existing transmission
export const useEditTransmission = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: editTransmission,
    onSuccess: data => {
      if (data?.success) {
        queryClient.invalidateQueries([TRANSMISSION_QUERY_KEY])
      }
    },
  })
}

// Delete a transmission
export const useDeleteTransmission = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: deleteTransmission,
    onSuccess: data => {
      if (data?.success) {
        queryClient.invalidateQueries([TRANSMISSION_QUERY_KEY])
      }
    },
  })
}
